import { SHAPE } from '../interfaces';
import { Area } from './area';
import { Ellipse } from './ellipse';
import { Line } from './line';
import { MultiRow } from './multi-row';
import { CurvedMultiRow } from './curved-multi-row';
import { Rectangle } from './rectangle';
import { RoundTable } from './round-table';
import { Row } from './row';
import { Table } from './table';
import { Text } from './text';
import { Icon } from './icon';
import { Image } from './image';
export * from './ellipse';
export * from './line';
export * from './multi-row';
export * from './curved-multi-row';
export * from './rectangle';
export * from './round-table';
export * from './row';
export * from './curved-row';
export * from './table';
export * from './text';
export * from './icon';
export * from './image';
export * from '../generic/pointer-area';
export * from '../generic/pointer-path';
export * from '../generic/row';
export * from '../generic/curved-row';
export * from '../generic/row/interfaces';
export * from '../generic/reverse-rotate';
export * from '../generic/rotate';
export const SHAPE_COMPONENT_MAP = {
    [SHAPE.AREA]: Area,
    [SHAPE.CIRCLE]: Ellipse,
    [SHAPE.LINE]: Line,
    [SHAPE.MULTI_ROW]: MultiRow,
    [SHAPE.CURVED_MULTI_ROW]: CurvedMultiRow,
    [SHAPE.RECTANGLE]: Rectangle,
    [SHAPE.ROUND_TABLE]: RoundTable,
    [SHAPE.ROW]: Row,
    [SHAPE.TABLE]: Table,
    [SHAPE.TEXT]: Text,
    [SHAPE.ICON]: Icon,
    [SHAPE.IMAGE]: Image,
};
//# sourceMappingURL=index.js.map